var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper profile-page" },
    [
      _c("div", { staticClass: "profile-header" }, [
        _c("div", { staticClass: "profile-header__avatar" }, [
          _c(
            "label",
            { staticClass: "avatar-upload" },
            [
              _vm.$_.get(_vm.user, "gravatar") === null && _vm.gravatar === null
                ? _c("a-avatar", { attrs: { size: 80, icon: "user" } })
                : _c("a-avatar", {
                    attrs: {
                      size: 80,
                      src: _vm.gravatar || _vm.$_.get(_vm.user, "gravatar"),
                    },
                  }),
              _vm._v(" "),
              _c("input", {
                staticClass: "d-none",
                attrs: { id: "profile-avatar", type: "file" },
                on: { change: _vm.uploadFile },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "avatar-overlay" },
                [_c("md-icon", [_vm._v("photo_camera")])],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-header__info" }, [
          _c("h2", { staticClass: "profile-header__name" }, [
            _vm._v(_vm._s(_vm.user.name)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "profile-header__email" }, [
            _vm._v(_vm._s(_vm.user.email)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "profile-header__badges" },
            [
              _c(
                "a-tag",
                { attrs: { color: "blue" } },
                [
                  _c("a-icon", { attrs: { type: "user" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.profile")) +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.user.isOnline
                ? _c(
                    "a-tag",
                    { attrs: { color: "green" } },
                    [
                      _c("a-icon", { attrs: { type: "check-circle" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("message.online")) +
                          "\n                "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-tabs",
        {
          staticClass: "profile-tabs",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("a-tab-pane", { key: "profile" }, [
            _c(
              "span",
              { attrs: { slot: "tab" }, slot: "tab" },
              [
                _c("a-icon", { attrs: { type: "user" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.profile")) +
                    "\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content" },
              [
                _c(
                  "div",
                  { staticClass: "settings-section" },
                  [
                    _c(
                      "h3",
                      { staticClass: "section-title" },
                      [
                        _c("a-icon", { attrs: { type: "edit" } }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.username")) +
                            "\n                    "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form",
                      { attrs: { layout: "vertical" } },
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: _vm.$t("message.username") } },
                          [
                            _c(
                              "a-input",
                              {
                                model: {
                                  value: _vm.userName,
                                  callback: function ($$v) {
                                    _vm.userName = $$v
                                  },
                                  expression: "userName",
                                },
                              },
                              [
                                _c("a-icon", {
                                  attrs: { slot: "prefix", type: "user" },
                                  slot: "prefix",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-form-item",
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary", icon: "save" },
                                on: { click: _vm.changeUserName },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.updateUserName")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "settings-section" },
                  [
                    _c(
                      "h3",
                      { staticClass: "section-title" },
                      [
                        _c("a-icon", { attrs: { type: "global" } }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.languageSettings")) +
                            "\n                    "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form",
                      { attrs: { layout: "vertical" } },
                      [
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: _vm.$t("message.languageSettings"),
                            },
                          },
                          [
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "250px" },
                                model: {
                                  value: _vm.lang,
                                  callback: function ($$v) {
                                    _vm.lang = $$v
                                  },
                                  expression: "lang",
                                },
                              },
                              _vm._l(_vm.languages, function (lng) {
                                return _c(
                                  "a-select-option",
                                  { key: lng.code, attrs: { value: lng.code } },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(lng.originalName) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-tab-pane", { key: "password" }, [
            _c(
              "span",
              { attrs: { slot: "tab" }, slot: "tab" },
              [
                _c("a-icon", { attrs: { type: "lock" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.changePassword")) +
                    "\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tab-content" }, [
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c(
                    "h3",
                    { staticClass: "section-title" },
                    [
                      _c("a-icon", { attrs: { type: "lock" } }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.changePassword")) +
                          "\n                    "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form",
                    {
                      staticClass: "password-form",
                      attrs: { layout: "vertical" },
                    },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("message.oldPassword") } },
                        [
                          _c(
                            "a-input-password",
                            {
                              model: {
                                value: _vm.oldPassword,
                                callback: function ($$v) {
                                  _vm.oldPassword = $$v
                                },
                                expression: "oldPassword",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "prefix", type: "key" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("message.newPassword") } },
                        [
                          _c(
                            "a-input-password",
                            {
                              model: {
                                value: _vm.newPassword,
                                callback: function ($$v) {
                                  _vm.newPassword = $$v
                                },
                                expression: "newPassword",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "prefix", type: "lock" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("message.passwordRepeat") } },
                        [
                          _c(
                            "a-input-password",
                            {
                              model: {
                                value: _vm.passwordConfirmation,
                                callback: function ($$v) {
                                  _vm.passwordConfirmation = $$v
                                },
                                expression: "passwordConfirmation",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "prefix", type: "lock" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", icon: "save" },
                              on: { click: _vm.changePassword },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("message.changePassword")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-tab-pane", { key: "notifications" }, [
            _c(
              "span",
              { attrs: { slot: "tab" }, slot: "tab" },
              [
                _c("a-icon", { attrs: { type: "bell" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.soundSettings")) +
                    "\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content" },
              [
                _c("div", { staticClass: "settings-section" }, [
                  _c(
                    "h3",
                    { staticClass: "section-title" },
                    [
                      _c("a-icon", { attrs: { type: "sound" } }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.soundSettings")) +
                          "\n                    "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sound-settings-grid" },
                    _vm._l(_vm.notificationSettings, function (setting, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "sound-setting-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "sound-setting-item__header" },
                            [
                              _c(
                                "span",
                                { staticClass: "sound-setting-item__title" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message." +
                                            _vm.getNotificationLabel(
                                              setting.type
                                            )
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "sound-setting-item__controls" },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "140px" },
                                  attrs: { size: "small" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.playPreviewSound(setting)
                                    },
                                  },
                                  model: {
                                    value: setting.soundFile,
                                    callback: function ($$v) {
                                      _vm.$set(setting, "soundFile", $$v)
                                    },
                                    expression: "setting.soundFile",
                                  },
                                },
                                _vm._l(_vm.soundFiles, function (s) {
                                  return _c(
                                    "a-select-option",
                                    { key: s, attrs: { value: s } },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(s) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "volume-control" },
                                [
                                  _c("a-slider", {
                                    staticStyle: { width: "100px" },
                                    attrs: { min: 0, max: 100, step: 10 },
                                    on: {
                                      afterChange: function ($event) {
                                        return _vm.playPreviewSound(setting)
                                      },
                                    },
                                    model: {
                                      value: setting.audioLevel,
                                      callback: function ($$v) {
                                        _vm.$set(setting, "audioLevel", $$v)
                                      },
                                      expression: "setting.audioLevel",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "volume-label" }, [
                                    _vm._v(_vm._s(setting.audioLevel) + "%"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("a-button", {
                                attrs: {
                                  type: "primary",
                                  shape: "circle",
                                  icon: "play-circle",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.playPreviewSound(setting)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "settings-section" }, [
                  _c(
                    "h3",
                    { staticClass: "section-title" },
                    [
                      _c("a-icon", { attrs: { type: "notification" } }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.desktopNotifications")) +
                          "\n                    "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "desktop-notifications-grid" },
                    _vm._l(
                      _vm.desktopNotificationSettings,
                      function (setting, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "notification-toggle-item",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "notification-toggle-item__info" },
                              [
                                _c("a-icon", {
                                  staticClass: "notification-icon",
                                  attrs: {
                                    type: _vm.getNotificationIcon(setting.type),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message." +
                                          _vm.getNotificationLabel(setting.type)
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("a-switch", {
                              model: {
                                value: setting.desktopNotification,
                                callback: function ($$v) {
                                  _vm.$set(setting, "desktopNotification", $$v)
                                },
                                expression: "setting.desktopNotification",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-tab-pane", { key: "sessions" }, [
            _c(
              "span",
              { attrs: { slot: "tab" }, slot: "tab" },
              [
                _c("a-icon", { attrs: { type: "laptop" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("sessions.mySessions")) +
                    "\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tab-content" }, [
              _c("div", { staticClass: "sessions-header" }, [
                _c("div", [
                  _c(
                    "h3",
                    { staticClass: "section-title" },
                    [
                      _c("a-icon", { attrs: { type: "laptop" } }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("sessions.mySessions")) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "section-desc" }, [
                    _vm._v(_vm._s(_vm.$t("sessions.mySessionsDesc"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sessions-actions" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { icon: "reload", loading: _vm.sessionsLoading },
                        on: { click: _vm.fetchMySessions },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.refresh")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "danger",
                          ghost: "",
                          icon: "disconnect",
                          disabled: _vm.otherSessionsCount === 0,
                        },
                        on: { click: _vm.handleRevokeAll },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("sessions.revokeAllOther")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.sessionsLoading
                ? _c(
                    "div",
                    { staticClass: "sessions-loading" },
                    [_c("a-spin", { attrs: { size: "large" } })],
                    1
                  )
                : _vm.mySessions.length === 0
                ? _c(
                    "div",
                    { staticClass: "sessions-empty" },
                    [
                      _c("a-empty", {
                        attrs: {
                          description: _vm.$t("sessions.noActiveSessions"),
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "sessions-list" },
                    _vm._l(_vm.mySessions, function (session) {
                      return _c("SessionCard", {
                        key: session._id,
                        attrs: { session: session },
                        on: { revoke: _vm.handleRevoke },
                      })
                    }),
                    1
                  ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }